import React from 'react';
import { Helmet } from "react-helmet";

const Hero = () => {
  const freshaBookingUrl = "https://www.fresha.com/a/zoteya-beauty-salon-sandton-33-wessel-road-bw27doko?pId=2602836";
  return (
    <>
      <Helmet>
        <title>Zoteya Beauty Salon | Best Sandton Hair Extensions, Braids, & Beauty</title>
        <meta name="description" content="Premium Sandton hair salon for women of color. Book luxury styling, braiding, and the best hair extensions in Johannesburg with expert stylists. Black-woman owned, 100% quality." />
      </Helmet>
      <section
        className="position-relative w-100 mb-4"
        style={{
          minHeight: "36vh",
          maxHeight: "336px",
          overflow: "hidden",
          background: "#f5f1eb",
        }}
      >
        <img
          src="https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1200&h=500&fit=crop&crop=center"
          alt="Modern hair salon interior with elegant styling station"
          className="w-100 h-100 position-absolute top-0 start-0"
          style={{
            objectFit: "cover",
            width: "100%",
            height: "100%",
            filter: "brightness(68%)",
            minHeight: "196px",
            zIndex: 1,
            maxHeight: 336
          }}
        />
        {/* Overlay */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center"
          style={{
            background: "rgba(0,0,0,0.28)",
            zIndex: 2,
            minHeight: "196px"
          }}
        >
          <div className="text-center">
            <h1
              className="fw-bold mb-2"
              style={{
                color: "#fff",
                fontFamily: "'Playfair Display',serif",
                fontSize: "1.38rem",
                textShadow: "0 2px 10px #000, 0 1px 0 #b6915d",
                letterSpacing: "0.065em",
                marginBottom: ".45em"
              }}
            >Zoteya Salon</h1>
            <p
              className="mb-3"
              style={{
                color: "#fff",
                fontSize: "1.03rem",
                textShadow: "0 1px 5px #8a7354, 0 2px 4px #000",
                fontWeight: "500",
                fontFamily: "Inter,sans-serif",
                letterSpacing: ".023em"
              }}
            >
              Hair is the crown of Glory
            </p>
            <a
              href={freshaBookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn px-4 py-2 fw-bold shadow-lg rounded-pill"
              style={{
                background: '#d4c4a8',
                color: '#3a3a3a',
                fontSize: ".97rem",
                letterSpacing: ".09em",
                textTransform: "uppercase",
                border: "none",
                boxShadow: "0 1.5px 11px #baa56044",
                transition: "background 0.3s, transform 0.2s"
              }}
              onMouseOver={e => (e.currentTarget.style.background = '#cab27c')}
              onMouseOut={e => (e.currentTarget.style.background = '#d4c4a8')}
            >
              Book Your Appointment
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
